import React, { useState } from 'react'
import {
	useDispatch,
	useSelector,
} from 'react-redux'
import {update} from './slice'
import {
	addItemToEvent,
	getEventDetails,
	replaceEventItem
} from '../../state/events'
import {capitalize} from '../../util/util'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import { useResource } from '../../hooks/resources'
import Select from "react-select"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Exercises from './Exercises/Exercises'
import Recipes from './Recipes/Recipes'
import Catalog from './Recipes/Catalog'
import Foods from './Foods/Foods'
import './Library.css'
import { Rnd } from "react-rnd" 

const LibraryHandle = () => {
	const statusDispatch = useApiStatusDispatch()
	const dispatch = useDispatch()
	//here we grab the library state that is part of the event editor
	const { 
		tgtResourceId:id, 
		tgtResourceType:type, 
		show 
	} = useSelector(state => state.resourceLibrary)
	//get replace state. This holds the id and type of the exercise
	//getting replaced. The id will be falsey if not replacing
	const replace = useSelector(state => state.resourceLibrary.replace)
	const replacing = Boolean(replace.id)
	return (
		<div className="library_resizeContainer">
			<i className="fas fa-sort" /> Expand
			<OverlayTrigger
				placement="top"
				overlay={
					<Tooltip>
						<p>Click And Drag To Expand </p>
					</Tooltip>
				}
			>
				<i className="ml-1 fas fa-info-circle" />
			</OverlayTrigger>

			<button 
				onClick={() => {
					dispatch(update({ show: !show }))
				}} 
				className="library_closeHandle"
			>
				Close {type === 'workout' ? 'Exercises' : 'Foods'}
			</button>
		</div>)
}

const ResourceTypeSelector = ({allowedSrcTypes=['exercise','food','recipe','recipe_catalog']})=>{
	const dispatch = useDispatch()
	const handleChange = e => {
		dispatch(update({
			resourceType:e.target.value
		}))
	}
	const {resourceType} = useSelector(state => state.resourceLibrary)

	const getLabel = label => {
		if(label==='recipe_catalog') return 'Recipe Catalog'
		if(label==='recipe') return 'My Recipes'
		return `${capitalize(label)}s`
	}

	return (
		<Form.Control
			value={resourceType}
			onChange={handleChange}
			className="mb-2"
			as="select"
			size="sm"
		>
			{allowedSrcTypes.map( t => (
				<option value={t}>{getLabel(t)}</option>
			))}
		</Form.Control>
	)
}

const Library = () => {
	const dispatch = useDispatch()
	//here we grab the library state that is part of the event editor
	const { tgtResourceId, resourceType, tgtResourceType, show } = useSelector(
		state => state.resourceLibrary
	)
	//get replace state. This holds the id and type of the exercise
	//getting replaced. The id will be falsey if not replacing
	const replace = useSelector(
		state => state.resourceLibrary.replace
	)

	const replacing = Boolean(replace.id)
	//get event from state
	const event = useResource(tgtResourceType, tgtResourceId)
	
	if (event?.simplified === 1) return null

	const style = {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		border: "solid 1px #ddd",
		position: 'absolute',
		height: '360px',
		maxHeight: '50%',
		background: '#fff',
		zIndex: 1002,
	}

	const allowedSrcTypes = {
		workout: ['exercise'],
		nutrition: ['recipe_catalog','recipe','food'],
		recipe: ['food'],
		//if replacing a meal only recipes should be selectable
		//otherwise only foods should be selectable
		meal: (
			replacing
			? ['recipe','recipe_catalog']
			: ['food']
		),
		meal_food: ['food'],
	}[tgtResourceType]

	const itemsComponent = ()=>{
		switch (resourceType) {
			case "exercise": return (
				<Exercises typeSelector={
					<ResourceTypeSelector allowedSrcTypes={allowedSrcTypes} />
				}/>
			)
			case "food": return (
				<Foods typeSelector={
					<ResourceTypeSelector allowedSrcTypes={allowedSrcTypes} />
				}/>
			)
			case "recipe": return (
				<Recipes typeSelector={
					<ResourceTypeSelector allowedSrcTypes={allowedSrcTypes} />
				}/>
			)
			case "recipe_catalog": return (
				<Catalog typeSelector={
					<ResourceTypeSelector allowedSrcTypes={allowedSrcTypes} />
				}/>
			)
		}
	}

	return (
		show &&
		<Rnd
			className={[
				"shadow border",
				"Events-Dropdown-Menu", 
				replacing && 'border-primary'
			].join(' ')}
			style={style}
			default={{
				x: 0,
				y: 0,
				width: '100%',
				height: '400px',
			}}
			maxHeight={"95%"}
			resizeGrid={[0.1, 0.1]}
			enableResizing={{
				top: false,
				right: false,
				bottom: true,
				left: false,
				topRight: false,
				bottomRight: false,
				bottomLeft: false,
				topLeft: false
			}}
			disableDragging={true}
			resizeHandleComponent={{ 
				bottom: <LibraryHandle /> 
			}}
		>
			<div
				style={{
					width: '100%',
					height: '100%',
					overflow: 'hidden',
				}}
			>
				{itemsComponent()}
			</div>

		</Rnd >
	)
}

export default Library